import { render, staticRenderFns } from "./AppHeroNewBlock.vue?vue&type=template&id=475c9da5&scoped=true"
import script from "./AppHeroNewBlock.vue?vue&type=script&lang=js"
export * from "./AppHeroNewBlock.vue?vue&type=script&lang=js"
import style0 from "./AppHeroNewBlock.vue?vue&type=style&index=0&id=475c9da5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c9da5",
  null
  
)

export default component.exports